import { createConsumer } from '@rails/actioncable';

/**
 * Single shared ActionCable consumer for the whole app.
 *
 * `createConsumer()` opens its own WebSocket per call — having two of them
 * (one for LivePresenceChannel, one for UserNotificationsChannel, etc.)
 * doubles the connection count and makes server-side per-connection
 * bookkeeping (presence, rate limits) noisier than it needs to be. Hooks
 * import `getCableConsumer()` and share a single WS, with their own
 * subscriptions multiplexed over it.
 */
let consumer = null;

export function getCableConsumer() {
  if (!consumer) consumer = createConsumer();
  return consumer;
}
